import countries from '../../../backend/config/document-countries.json';
import aliases from '../../../backend/config/document-country-aliases.json';

export const documentCountries: Record<string, string> = countries;

export interface DocumentIdentity {
  tipo_documento: string;
  documento: string;
  pais_documento?: string | null;
  nacionalidad?: string | null;
}

export function documentCountry(data: DocumentIdentity): string {
  if (['CI', 'RUT'].includes(data.tipo_documento)) return 'UY';
  if (data.pais_documento?.trim()) return data.pais_documento.trim().toUpperCase();
  const key = (data.nacionalidad || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();
  const country = (aliases as Record<string, string>)[key];
  return typeof country === 'string' ? country : '';
}

export function documentIdentityKey(data: DocumentIdentity): string {
  const national = ['CI', 'RUT'].includes(data.tipo_documento);
  const number = national ? data.documento.replace(/[.\-\s]/g, '') : data.documento.trim();
  return JSON.stringify([data.tipo_documento, number, documentCountry(data)]);
}
